import React, {useEffect, useRef, useState} from "react";
import {Popover, PopoverBody} from "reactstrap";
import {useDispatch, useSelector} from "react-redux";
import statisticReducer from "../../../store/reducers/statisticReducer";
import Spinner from "../Spinner";
import {loadTbStatisticDetails} from "../../../actions/statisticActions";
import {getMoneyString} from "../../../utils/formatUtils";
import {isAdmin, isPartner} from "../../../utils/authUtils";

export default function TrafficBackTooltip({ children, onClick, rowId, getRowFilterData }) {
    const [showTooltip, setShowTooltip] = useState(false);
    const id = 'popover_' + rowId;

    const tbStatisticData = useSelector(state => state.statisticReducer.tbStatisticData);
    const loadingTbStatistic = useSelector(state => state.statisticReducer.loadingTbStatistic);
    const isLoggedAsPartner =  useSelector(state => state.auth.isPartner) || useSelector(state => state.auth.isAdminAsPartner);

    let dispatch = useDispatch();

    let timeoutId = null;
    const ref = useRef();

    useEffect(() => {
        if (!showTooltip || isPartner()) {
            return;
        }
        const filterData = getRowFilterData && getRowFilterData();
        dispatch(loadTbStatisticDetails(filterData));
    }, [showTooltip]);

    useEffect(() => {
        if (!ref?.current) {
            return;
        }
        const offsetHeight = ref?.current?.offsetHeight;
        if (offsetHeight) {
            const windowHeight = window.innerHeight;
            const rect = document.getElementById(id).getBoundingClientRect();
            const popover = document.getElementsByClassName(id) && document.getElementsByClassName(id)[0];
            if (popover && popover.getBoundingClientRect().bottom > windowHeight) {
                let top = (windowHeight - offsetHeight)/2;
                popover.style.transform = `translate3d(${rect?.x + 50}px, ${top}px, 0px)`;
            }
        }


    }, [ref?.current]);

    const handleMouseEnter = (e) => {
        timeoutId = setTimeout(() => {
            setShowTooltip(true);
        }, 500);
    };

    const handleMouseLeave = () => {
        clearTimeout(timeoutId);
        setShowTooltip(false);
    };


    const statisticContent = () => {
        if (!tbStatisticData) {
            return <div>Нетданных. Попробуйте позднее</div>
        }
        return tbStatisticData.map(item =>
            <div key={item.description} className="font-12">
                <span><b>{item.amount.toLocaleString("ru-RU")  + " | " + getMoneyString(item.percent)}%</b></span>
                <span > - {item.description}</span>
            </div>)
    };

    return (
        isLoggedAsPartner
            ?
                <a id={id} href="#" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} onClick={onClick}>
                    {children}
                </a>
            :
                <>
                    <a id={id} href="#" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} onClick={onClick}>
                        {children}
                    </a>
                    {showTooltip &&
                    <div><Popover isOpen={showTooltip} target={id} popperClassName={"min-width-400 " + id} style={{maxHeight: '95vh'}} placement="right" hideArrow>
                        {loadingTbStatistic
                            ? <div><Spinner/></div>
                            : <PopoverBody style={{maxHeight: '95vh'}} >
                                <div ref={ref} style={{maxHeight: '94vh', overflowY: 'hidden'}} >{statisticContent()}</div>
                            </PopoverBody>}
                    </Popover></div>}

                </>
    );
}